import {
  Button,
  HeadingRegular,
  Modal,
  NavigationItem,
} from '@pensionbee/honeypot-ui';
import { useState } from 'react';
import { useThemedImageSource } from '@/domains/theme/useThemedImageSource';
import { StageProps } from '../../config/StrongerNudgeConfig';

interface PensionBeeBookingOptionProps {
  isConfirmationScreen?: boolean;
}

export const PensionBeeBookingOption = (
  props: PensionBeeBookingOptionProps & { onSubmit: StageProps['onSubmit'] },
) => {
  const { isConfirmationScreen, onSubmit } = props;
  const customerServiceIcon = useThemedImageSource('spot-customer-service');
  const [isOpenPensionBeeBooking, setIsOpenPensionBeeBooking] = useState(false);

  const closePensionBeeBooking = () => setIsOpenPensionBeeBooking(false);

  const openPensionBeeBooking = () => setIsOpenPensionBeeBooking(true);

  const handleCallPensionBee = async () => {
    await onSubmit({
      [isConfirmationScreen
        ? 'guidanceConfirmationOption'
        : 'guidanceAppointmentChoice']: 'PensionBee Booking',
    });
    const phoneNumberHref = 'tel:+442034578444';
    window.location.href = phoneNumberHref;
    closePensionBeeBooking();
  };

  return (
    <>
      <NavigationItem
        handleClick={openPensionBeeBooking}
        title={'Request PensionBee book your appointment'}
        copy={
          isConfirmationScreen
            ? "Call us on 020 3457 8444 if you'd like us to book another appointment for you."
            : "Call us on 020 3457 8444 if you'd like us to book your appointment for you."
        }
        src={customerServiceIcon}
        imageHeight="48px"
      />
      <Modal
        isOpen={isOpenPensionBeeBooking}
        handleClose={closePensionBeeBooking}
        variant="bottom"
      >
        <div className="flex h-full flex-col justify-between">
          <HeadingRegular className="mb-28">
            You&apos;ll need to confirm you&apos;ve taken guidance before you
            can proceed.
          </HeadingRegular>
          <Button
            className="mb-20 mt-auto w-full md:w-auto"
            onClick={handleCallPensionBee}
          >
            OK
          </Button>
          <Button
            variant="secondary"
            className="mt-auto w-full md:w-auto"
            onClick={closePensionBeeBooking}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
};
